module.exports = __webpack_public_path__ + "static/img/2-right.c7d2275.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ability/img/2-right.png
// module id = XyKO
// module chunks = 1